import { buildQueryString } from "../../../helpers/buildQueryString";
import { publicRequest } from "../../../requestMeth";
import {
  passiveLoadStart,
  passiveLoadSuccess,
  passiveLoadFailure,
} from "../../reducers/analysis/passiveLoadRedux";

const pad = (n) => (n < 10 ? `0${n}` : n);

const formatDate = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const getPassiveLoadData = async (
  dispatch,
  token,
  mac,
  startDate,
  endDate,
  frec,
  branchId,
  companyId,
) => {

  dispatch(passiveLoadStart());

  try {

    const query = buildQueryString({
      mac: Array.isArray(mac) ? mac.join(",") : mac,
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
      frec,
      branchId,
      companyId,
    });

    const res = await publicRequest.get(`/analysis/passive-load?${query}`, {
      headers: { token: `Bearer ${token}` },
    });

    dispatch(passiveLoadSuccess(res.data));

    return res.data;

  } catch (err) {

    dispatch(passiveLoadFailure());

    throw err;
  }
};